import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import './PageTemplate.css';

/**
 * 通用页面模板组件
 * 用于保持所有子页面的一致性
 */
const PageTemplate = ({ 
  titleKey, 
  customTitle,
  subtitleKey, 
  children, 
  headerImage,
  breadcrumbs,
  documentTitleKey  // 新增：专门用于浏览器标题的键
}) => {
  const { t } = useTranslation();
  const browserTitleKey = documentTitleKey || (titleKey ? titleKey.split('.')[1] : null);
  // customTitle 是文章标题字符串，不是 i18n key，不能传给 useDocumentTitle
  useDocumentTitle(customTitle ? null : browserTitleKey);
  React.useEffect(() => {
    if (customTitle) {
      document.title = customTitle;
      return () => { document.title = t('pageTitle.home'); };
    }
  }, [customTitle, t]);

  return (
    <div className="page-template">
      {/* 页面头部横幅 */}
      <div className="page-header" style={headerImage ? { backgroundImage: `url(${headerImage})` } : {}}>
        <div className="page-header-content">
          {breadcrumbs && (
            <nav className="breadcrumbs">
              {breadcrumbs.map((crumb, index) => (
                <span key={index}>
                  {index > 0 && <span className="separator"> / </span>}
                  {crumb.href ? (
                    <a href={crumb.href}>{crumb.labelKey ? t(crumb.labelKey) : crumb.label}</a>
                  ) : (
                    <span className="current">{crumb.labelKey ? t(crumb.labelKey) : crumb.label}</span>
                  )}
                </span>
              ))}
            </nav>
          )}
          <h1 style={{ whiteSpace: 'pre-line' }}>{customTitle || t(titleKey)}</h1>
          {subtitleKey && <p className="subtitle">{t(subtitleKey)}</p>}
        </div>
      </div>

      {/* 页面主要内容 */}
      <div className="page-content">
        {children}
      </div>
    </div>
  );
};

export default PageTemplate;
